import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
/*servicio*/
import { UserService } from '../user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuardService implements CanActivate {
  
  constructor(private _userService:UserService) { }

  canActivate():boolean{
    if(this._userService.getUsuario().role==='USER_ADMIN'){
      return true;
    }
    console.log('Bloqueado por el guard');
    this._userService.logout();
    return false;
  }

}
